<template>
  <v-autocomplete
    ref="select"
    v-model="contractId"
    :items="contracts"
    :label="'Договор страхования'"
    :rules="[requiredRules]"
    required
    :readonly="props.byContract"
    item-value="id"
    item-text="text"
    clearable
    @update:search-input="getContractByCardNo"
    @change="emitSelect"
  >
  </v-autocomplete>
</template>

<script>
import fetch from "../../utils/fetch";

export default {
  name: "ContractsSelect",
  props: {
    props: Object
  },
  data() {
    return {
      requiredRules: v => !!v || "Обязательное поле",
      contracts: [],
      loading: false,
      page: 1,
      totalPages: 1,
      contractId: null,
      currentInput: null
    };
  },
  methods: {
    async getContract() {
      if (this.props.id == null) return;
      this.contractId = this.props.id;
      const result = await fetch.get(
        `/api/insurance/contracts/${this.contractId}`
      );
      if (!result) return;
      // Контракт мог смениться, пока шёл запрос
      if (this.props.id !== result.id) return;
      this.contracts = [
        {
          id: result.id,
          text: result.number
        }
      ];
      this.contractId = result.id;
    },

    async getContractByCardNo(input) {
      if (!input || this.currentInput === input) return;
      this.loading = true;
      const result = await fetch.get(
        `/api/insurance/contracts/get-by-number?number=${input}`
      );
      this.contracts = [];
      if (result) {
        result.forEach(contract => {
          this.contracts.push({
            id: contract.id,
            text: contract.number
          });
        });
      }
      this.loading = false;
      this.currentInput = input;
    },

    initialize() {
      this.contracts = [];
      this.currentInput = null;
      this.contractId =
        this.props.id !== null && this.props.id !== undefined
          ? this.props.id
          : null;
      if (this.contractId != null) {
        this.getContract();
      }
    },

    emitSelect() {
      if (this.contractId == null) {
        this.$emit("contractSelected", null);
        return;
      }
      const contract = this.contracts.find(c => c.id === this.contractId);
      this.$emit("contractSelected", contract || { id: this.contractId });
    }
  },

  watch: {
    "props.id": function() {
      this.initialize();
    }
  },

  mounted() {
    this.initialize();
  }
};
</script>
